var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { get } from "lodash";
import store from '../redux/store';
import { fetchMerchants, setSelectedMerchant } from '../modules/merchantSelector/merchantSelectorSlice';
import { isVirtualEntitySystemEnabled } from "./featureFlagHelper";
import { MERCHANT_LEVEL } from "../constants";
import { setSelectedResource } from "./permissionsUtils";
export var VIRTUAL_ENTITY = "VIRTUAL";
export var getUserGrabID = function () {
    try {
        if (localStorage.getItem("userprofileInfo")) {
            var userProfile = JSON.parse(localStorage.getItem("userprofileInfo") || "");
            return get(userProfile, ["user_profile", "grab_id"]);
        }
    }
    catch (e) {
        console.error("unable to parse userprofile from LS");
    }
    return "";
};
export var setSelectedMerchantIdInLocalStorage = function (selectedMerchant) {
    var _a;
    var selectedMerchantObj = __assign(__assign({}, getSelectedMerchantIds()), (_a = {}, _a[getUserGrabID()] = selectedMerchant, _a));
    if (selectedMerchant) {
        localStorage.setItem('selectedMerchant', JSON.stringify(selectedMerchantObj));
        setSelectedResource(selectedMerchant.id || "", MERCHANT_LEVEL);
    }
    else {
        localStorage.removeItem('selectedMerchant');
    }
};
export var getSelectedMerchantIdFromLocalStorage = function () {
    var _a;
    try {
        if (localStorage.getItem('selectedMerchant')) {
            var userSelectedMerchant = JSON.parse(localStorage.getItem('selectedMerchant') || "");
            return (_a = userSelectedMerchant[getUserGrabID()]) === null || _a === void 0 ? void 0 : _a.id;
        }
    }
    catch (e) {
        console.error("unable to parse userSelectedMerchant from LS");
    }
    return "";
};
export var getSelectedMerchantIds = function () {
    try {
        var userSelectedMerchant = JSON.parse(localStorage.getItem('selectedMerchant') || "");
        return userSelectedMerchant;
    }
    catch (e) {
        console.error("unable to parse userSelectedMerchant from LS");
    }
    return null;
};
export var getSelectedMerchantTypeFromLS = function () {
    var _a;
    try {
        var userSelectedMerchant = JSON.parse(localStorage.getItem('selectedMerchant') || "");
        return (_a = userSelectedMerchant[getUserGrabID()]) === null || _a === void 0 ? void 0 : _a.type;
    }
    catch (e) {
        console.error("unable to parse userSelectedMerchant from LS");
    }
    return "";
};
export var isSelectedMerchantVE = function () {
    var _a;
    if (!isVirtualEntitySystemEnabled()) {
        return false;
    }
    try {
        var userSelectedMerchant = JSON.parse(localStorage.getItem('selectedMerchant') || "");
        return ((_a = userSelectedMerchant[getUserGrabID()]) === null || _a === void 0 ? void 0 : _a.type) === VIRTUAL_ENTITY;
    }
    catch (e) {
        console.error("unable to parse userSelectedMerchant from LS");
    }
    return false;
};
export var getSelectedMerchantNameFromLS = function () {
    var _a;
    try {
        var userSelectedMerchant = JSON.parse(localStorage.getItem('selectedMerchant') || "");
        return (_a = userSelectedMerchant[getUserGrabID()]) === null || _a === void 0 ? void 0 : _a.display_name;
    }
    catch (e) {
        console.error("unable to parse userSelectedMerchant from LS");
    }
    return "";
};
export var getSelectedMerchantHeader = function () {
    if (!isVirtualEntitySystemEnabled()) {
        return {};
    }
    try {
        var merchant_id = getSelectedMerchantIdFromLocalStorage();
        var header = { "X-MERCHANT-ID": merchant_id };
        return merchant_id ? header : {};
    }
    catch (e) {
        console.error("merchant header not available yet");
    }
    return {};
};
export var getSelectedMerchantReqObj = function () {
    if (!isVirtualEntitySystemEnabled()) {
        return {};
    }
    try {
        var merchant_id = getSelectedMerchantIdFromLocalStorage();
        var req = { "merchant_group_id": merchant_id };
        return merchant_id ? req : {};
    }
    catch (e) {
        console.error("selected merchant id not available");
    }
    return {};
};
/**
 * Fetches merchants and selects one based on predefined criteria.
 */
export function fetchAndSelectMerchant() {
    return __awaiter(this, void 0, void 0, function () {
        var dispatch, merchants, storedMerchantId_1, selectedMerchant, normalMerchant, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isVirtualEntitySystemEnabled()) {
                        return [2 /*return*/];
                    }
                    dispatch = store.dispatch;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dispatch(fetchMerchants()).unwrap()];
                case 2:
                    merchants = _a.sent();
                    if (!merchants || merchants.length === 0) {
                        console.error("No merchants found");
                        return [2 /*return*/];
                    }
                    storedMerchantId_1 = localStorage.getItem('selectedMerchantId');
                    selectedMerchant = merchants.find(function (merchant) { return merchant.id === storedMerchantId_1; });
                    if (storedMerchantId_1 && selectedMerchant) {
                        dispatch(setSelectedMerchant(selectedMerchant));
                    }
                    else if (merchants.length === 1) {
                        dispatch(setSelectedMerchant(merchants[0]));
                    }
                    else {
                        normalMerchant = merchants.find(function (merchant) { return merchant.type !== VIRTUAL_ENTITY; });
                        normalMerchant ? dispatch(setSelectedMerchant(normalMerchant)) : dispatch(setSelectedMerchant(merchants[0]));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error("Failed to fetch and select merchants:", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
/**
 * Fetches merchants and selects one based on predefined criteria.
 */
export function initialiseSelectedMerchant(merchants) {
    return __awaiter(this, void 0, void 0, function () {
        var storedMerchantId_2, selectedMerchant, normalMerchant;
        return __generator(this, function (_a) {
            try {
                if (!isVirtualEntitySystemEnabled()) {
                    return [2 /*return*/];
                }
                if (!merchants || merchants.length === 0) {
                    console.error("No merchants found");
                    return [2 /*return*/];
                }
                storedMerchantId_2 = getSelectedMerchantIdFromLocalStorage();
                selectedMerchant = merchants.find(function (merchant) { return merchant.id === storedMerchantId_2; });
                if (storedMerchantId_2 && selectedMerchant) {
                    setSelectedMerchantIdInLocalStorage(selectedMerchant);
                }
                else if (merchants.length === 1) {
                    setSelectedMerchantIdInLocalStorage(merchants[0]);
                }
                else {
                    normalMerchant = merchants.find(function (merchant) { return merchant.type !== VIRTUAL_ENTITY; });
                    normalMerchant ? setSelectedMerchantIdInLocalStorage(normalMerchant) : setSelectedMerchantIdInLocalStorage(merchants[0]);
                }
            }
            catch (error) {
                console.error("Failed to fetch and select merchants:", error);
            }
            return [2 /*return*/];
        });
    });
}
//# sourceMappingURL=merchantSelectorHelper.js.map